var render, staticRenderFns
import script from "./submit_approve.vue?vue&type=script&lang=js"
export * from "./submit_approve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1604bf71')) {
      api.createRecord('1604bf71', component.options)
    } else {
      api.reload('1604bf71', component.options)
    }
    
  }
}
component.options.__file = "found/components/submit_approve/submit_approve.vue"
export default component.exports